export const objectStorageUrl = <T extends string>(path: T extends `/${string}` ? never : T) => {
  return `${process.env.NEXT_PUBLIC_OBJECT_STORAGE_URL}/web/assets/${path}`
}
